import axiosHttp from "../interceptor";
import { CARBON_DILIGENCE_APIS } from "./api-definitions";
import axios from "axios";
import {
	WEBHOOK_STATUS_URL,
	WEBHOOK_CANCEL_URL,
	WEBHOOK_ENQUEUE_URL,
} from "./api-definitions";

const getTypeAndAPI = (CARBON_DILIGENCE_APIS, API_NAME) => {
	return CARBON_DILIGENCE_APIS.find((element) => {
		return element.name === API_NAME;
	});
};

export const accessAPIForResponse = async (
	API_NAME,
	requestPayLoad,
	requestParamsList
) => {
	const API_OBJECT = getTypeAndAPI(CARBON_DILIGENCE_APIS, API_NAME);
	const API_TYPE = API_OBJECT.type;
	const API = API_OBJECT.api;
	let response = "";

	try {
		if (API_TYPE === "post" || API_TYPE === "put") {
			response = API_TYPE === "post"?  await axiosHttp.post(API, requestPayLoad) : await axiosHttp.put(API, requestPayLoad);
			return response?.data;
		} else if (API_TYPE === "get") {
			const requestParams = requestParamsList
				.map((item) => `=${encodeURIComponent(item)}`)
				.join("&");
			response = await axiosHttp.get(API + requestParams);
			return response?.data;
		} 
		else if (API_TYPE === "delete") {
			const requestParams = requestParamsList
				.map((item) => `=${encodeURIComponent(item)}`)
				.join("&");
			response = await axiosHttp.delete(API + requestParams);
			return response?.data;
		}
		else if (API_TYPE === "export") {
			const requestParams = requestParamsList
				.map((item) => `=${item}`)
				.join("&");
			response = await axiosHttp.get(API + requestParams, {
				responseType: "blob",
			});
			return response.data;
		} else if (API_TYPE === "blob") {
			response = await axiosHttp.post(API, requestPayLoad, {
				responseType: "blob",
			});
			return response?.data;
		} 
	} catch (error) {
		console.error(error);
	}
};

export const getWebhookStatus = (webhookId) => {
	return axios.get(`${WEBHOOK_STATUS_URL}/${webhookId}`);
};

export const cancelWebhookOperation = (webhookId) => {
	return axios.post(`${WEBHOOK_CANCEL_URL}/${webhookId}`);
};

export const enqueueWebhookOperation = (payload) => {
	return axios.post(WEBHOOK_ENQUEUE_URL, payload);
};
